import { render } from "./CourseStudy.vue?vue&type=template&id=154c6fb5&scoped=true"
import script from "./CourseStudy.vue?vue&type=script&lang=js"
export * from "./CourseStudy.vue?vue&type=script&lang=js"

import "./CourseStudy.vue?vue&type=style&index=0&id=154c6fb5&lang=less&scoped=true"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-154c6fb5"]])

export default __exports__